export const formatArrayToString = (value: string | string[]): string => {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  return value;
};
